import Vue from 'vue';
import { mapGetters } from 'vuex';
import { siteBuilder } from '@/mixins/site-builder';
import dropsLoader from '@/mixins/components/drops-loader';
import tooltip from '@/mixins/components/tooltip';

export default Vue.component('preview-options', {
  name: 'preview-options',
  template: require('./template.html'),
  mixins: [siteBuilder],
  computed: {
    ...mapGetters([
      'currentPage',
      'currentSite',
      'previewOptions',
    ]),
    isPage() {
      return this.currentPage.type === 'page';
    },
    isUnpublished() {
      return this.isPage && this.currentPage.status === 'unpublished';
    },
    liveViewTip() {
      let tip = '';
      if (!this.$demo && !this.currentSite.cloudFront.domain) {
        tip = 'This site is not on a hosted plan.';
      }
      if (!this.isPage) {
        tip = 'Only pages are viewable.';
      }
      if (this.isUnpublished) {
        tip = 'Only published pages are viewable.';
      }
      if (this.$demo) {
        tip = 'Disabled for demo.';
      }
      return tip;
    },
    previewTip() {
      let tip = '';
      if (!this.isPage) {
        tip = 'Only pages are previewable.';
      }
      if (this.$demo) {
        tip = 'Disabled for demo.';
      }
      return tip;
    },
  },
  components: {
    dropsLoader,
    tooltip,
  },
  data() {
    return {
      loaders: {
        preview: false,
      },
    };
  },
  methods: {
    async viewPage(type) {
      if (this.$demo) {
        return;
      }
      if (!this.isPage) {
        return;
      }
      if (this.isUnpublished && type === 'published') {
        return;
      }
      if (!this.currentSite.cloudFront.domain && type === 'published') {
        return;
      }
      this.loaders.preview = true;
      let url = '';
      try {
        const template = this.currentPage.type === 'template';
        if (type === 'published') {
          const pageUrl = template ? '/' : this.currentPage.url;
          const page = this._formatLink(pageUrl);
          url = `https://${this.currentSite.cloudFront.domain}${page}`;
        }
        if (type === 'preview') {
          const { previewLink, metrics } = await this.callBuilder({
            publish: 'page',
            type: 'preview',
            currentPage: this.currentPage,
            template,
            site: {
              _id: this.currentSite._id,
            },
            page: {
              _id: this.currentPage._id,
            },
          });
          this.$log.info('preview metrics: ', metrics);
          url = previewLink;
        }
        window.open(url, '_blank');
        this.$store.dispatch('setPreviewOptions', !this.previewOptions);
      } catch (e) {
        this.$log.error('error: ', e);
        await this._reportError({
          error: e,
          fn: 'preview: openPage',
        });
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'error',
          message: `${e.message || e}. This has been reported.`,
        });
      } finally {
        this.loaders.preview = false;
        this._trackEvent({
          type: 'preview_page',
          meta: {
            preview_type: type,
            site_name: this.currentSite.alias,
            site_type: this.currentSite.type,
            site_tier: this.currentSite.tier,
            page_name: this.currentPage.name,
            page_url: this.currentPage.url,
            blocks: this.currentPage.blocks.length,
          },
        });
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/preview-options/index.js